import {connect, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import * as config from "../../../config";


const useStyles = makeStyles(theme => ({
    mainGrid:{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'center'

    },
    navLogo: {
        margin: '0px',
        height: "450px",
        // width: "966px",
        verticalAlign: 'middle'
    },


}));


const PainelTVLogo = ( props ) => {
    const classes = useStyles();

    const [show, setShow] = useState(false);
    const st = useSelector(state => state);
    const etapas = useSelector(state => state.stations.etapas);

    useEffect( () => {
    }, [props.contador]);

    const imglogo = `/images/tnt${config.getTntFolder()}/logoEmpresaBco.png`;

    return (
        <React.Fragment>
            <Grid container className={classes.mainGrid}>
                <Grid item container className={classes.mainGrid} style={{marginTop:'100px'}} xs={6} sm={6} lg={6} xl={6}>
                    <img src={imglogo} className={classes.navLogo} alt='logo'/>
                </Grid>
            </Grid>
        </React.Fragment>
    )

}

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.id !== null && (state.auth.expiresIn * 1000 > new Date().getTime()),
        auth: state.auth,
        error: state.filter.error,
    }
}


export default connect(mapStateToProps,{})(PainelTVLogo);
